import { get } from 'lodash';
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { currencyMapper } from '@nexio/emvio-util-app';

import ColorDollarAmountCell from '../../Table/Cells/ColorDollarAmountCell/ColorDollarAmountCell';
import { prettifyDate } from '../../../utils/string';
import './SpendbackListItem.scss';

export default class SpendbackListItem extends Component {
    static propTypes = {
        item: PropTypes.any,

        onGoToItem: PropTypes.func.isRequired
    };

    renderDate(date) {
        return date ? prettifyDate(date, { returnDateOnly: true }) : 'No Date';
    }

    renderSpendbackAccount(spendbackAccountName) {
        return spendbackAccountName ? spendbackAccountName : 'No Spendback Account';
    }

    render() {
        const spendback = this.props.item;
        const currencyCode = get(currencyMapper, spendback.currencyId, '840').code;

        return (
            <div
                className="spendback-list-item"
                onClick={this.props.onGoToItem}
            >
                <div className="spendback-list-item-left">
                    <span className="spendbacks-date">
                        {this.renderDate(spendback.spendbackDate)}
                    </span>
                    <span className="spendback-spendback-account">
                        {this.renderSpendbackAccount(spendback.spendbackAccountName)}
                    </span>
                </div>
                <div className="spendback-list-item-right">
                    <span className="spendback-amount">
                        <ColorDollarAmountCell amount={spendback.amount} currencyCode={currencyCode}/>
                    </span>
                </div>
            </div>
        );
    }
}
